import type { FaireProductEntity } from "../../entity_types/product";

export const p_g254w6nqc3: FaireProductEntity = {
  token: "p_g254w6nqc3",
  type: "product",
  name: "Crystal Healing for Animals",
  brandToken: "b_elwnrzazbf",
  brandName: "Microcosm Publishing & Distribution",
  imageUrl:
    "https://cdn.faire.com/fastly/1c424a29f05d7a73776d6f85ff6436799c150b030b0c90db205d4fbf81113cbc.jpeg",
  galleryImageUrls: [],
  priceDollars: 14.51,
  description:
    "Harness the ancient art of crystal healing to improve the wellbeing of animals in your care with this comprehensive guide. Crystals can offer profound, gentle healing benefits for pets, and their use is accessible to both novices and experienced practitioners. The book covers techniques for selecting and cleansing crystals, using crystal layouts, and creating crystal essences. It provides practical advice on addressing a range of issues, from stress and allergies to post-surgical recovery and behavior problems. Additionally, it includes guidance on training and animal rescue, emphasizing the supportive role of crystals in these areas.",
  tags: [],
  msrpDollars: 20.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:33.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
